/**
 * html2canvas는 repeating-linear-gradient 빗금을 자주 생략한다.
 * PDF 캡처 직전 클론에서 SVG data-URI 패턴으로 치환한다.
 */

function svgDataUrl(svg: string): string {
  return `url("data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}")`;
}

/** -45° 빗금 (2px 면 + 2px 줄 ≈ 주기 4√2 ≈ 6px 타일) */
function diagonalHatchDataUrl(bg: string, stripe: string): string {
  const size = 6;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">` +
    `<rect width="${size}" height="${size}" fill="${bg}"/>` +
    `<path d="M-1 ${size - 1} L${size - 1} -1 M1 ${size + 1} L${size + 1} 1" stroke="${stripe}" stroke-width="2" fill="none"/>` +
    `</svg>`;
  return svgDataUrl(svg);
}

/** 세로 줄무늬 (3px 공백 + 1px 줄) */
function verticalHatchDataUrl(bg: string, stripe: string): string {
  const size = 4;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">` +
    `<rect width="${size}" height="${size}" fill="${bg}"/>` +
    `<rect x="3" y="0" width="1" height="${size}" fill="${stripe}"/>` +
    `</svg>`;
  return svgDataUrl(svg);
}

const HATCH_UNUSED = {
  bg: '#ffffff',
  image: diagonalHatchDataUrl('#ffffff', 'rgba(128,128,128,0.28)'),
  size: '6px 6px',
} as const;

const HATCH_ACTIVITY = {
  bg: '#f5f0e6',
  image: diagonalHatchDataUrl('#f5f0e6', 'rgba(255,255,255,0.85)'),
  size: '6px 6px',
} as const;

const HATCH_CALENDAR_NON_CLASS = {
  bg: 'rgba(96,125,139,0.12)',
  image: verticalHatchDataUrl('rgba(96,125,139,0.12)', 'rgba(96,125,139,0.35)'),
  size: '4px 4px',
} as const;

function applyHatchStyle(
  el: HTMLElement,
  hatch: { bg: string; image: string; size: string }
): void {
  el.style.setProperty('background-color', hatch.bg, 'important');
  el.style.setProperty('background-image', hatch.image, 'important');
  el.style.setProperty('background-size', hatch.size, 'important');
  el.style.setProperty('background-repeat', 'repeat', 'important');
  el.style.setProperty('background-position', '0 0', 'important');
}

/** A4·주간학습 안내 PDF 캡처 클론용 — 빗금 셀을 SVG 패턴으로 고정 */
export function bakeWeeklyGuideHatchBackgroundsForHtml2Canvas(root: HTMLElement): void {
  root
    .querySelectorAll<HTMLElement>('td.cp-weekly-cell-no-class.cp-weekly-cell-unused-kind')
    .forEach((el) => applyHatchStyle(el, HATCH_UNUSED));

  root
    .querySelectorAll<HTMLElement>('td.cp-weekly-cell-activity-hatch')
    .forEach((el) => applyHatchStyle(el, HATCH_ACTIVITY));

  root
    .querySelectorAll<HTMLElement>('td.cp-weekly-cell-calendar-non-class')
    .forEach((el) => applyHatchStyle(el, HATCH_CALENDAR_NON_CLASS));
}
